export const environment = {
    production: true,
    application: "JNBKarta",
    baseApiUrl: "__NVDB_BASE_API_URL__",
    adfsResource: "__NVDB_BASE_API_URL__",
    streetViewApiKey: "__NVDB_STREET_VIEW_API_KEY__",
    buildVersion: "__NVDB_BUILD_VERSION__",
    clientId: "__NVDB_CLIENT_ID__",
    authority: "__NVDB_AUTHORITY__",
    local: "__NVDB_IS_LOCAL__",

    //APM
    apmServiceName: "__NVDB_APM_SERVICE_NAME__",
    apmServerUrl: "__NVDB_APM_SERVER_URL__",
    apmEnvironment: "__NVDB_APM_ENVIRONMENT__",
    apmDistributedTracingOrigins: "__NVDB_APM_DISTRIBUTED_TRACING_ORIGINS__",
    apmDistributedTracing: "__NVDB_APM_DISTRIBUTED_TRACING__",
    apmEnabled: "__NVDB_APM_ENABLED__"
};
